export default {
	pageTitle: "Schedule",

	//
	// components
	//

	//
	// ScheduleDay
	//
	ScheduleDay_todayChip: "TODAY",
	ScheduleDay_noMeetingsMessage: "You have no meetings on this date.",
	ScheduleDay_allMeetingsFiltered: "All events on this date filtered or hidden from view.",

	//
	// ScheduleMeeting
	//
	ScheduleMeeting_noTopics: "No topics",
	ScheduleMeeting_singularTopic: "topic",
	ScheduleMeeting_pluralTopic: "topics",
	ScheduleMeeting_unpinnedTopicCount: "{count} {topicNoun}",
	ScheduleMeeting_allTopicCounts: "{count} {topicNoun} ({pinnedCount} pinned)",
	ScheduleMeeting_recurringChip: "Recurring",
	ScheduleMeeting_recurringTeamChip: "Team Meeting",
	ScheduleMeeting_connectTeamLabel: "Connect a team",
	ScheduleMeeting_showMeetingInTeaming: "Show meeting in Teaming",
	ScheduleMeeting_hideMeetingInTeaming: "Hide meeting in Teaming",
	ScheduleMeeting_meetingHidden: "Hidden",
	// TODO: implementation
	ScheduleMeeting_connectTeamOrOneOnOneLabel: "Connect a team or designate as a 1:1",

	//
	// ScheduleMeetingPlaceholder
	//
	ScheduleMeetingPlaceholder_title: "No meeting selected",
	ScheduleMeetingPlaceholder_description: "To start a meeting, add or edit agenda items for upcoming meetings, or review outcomes from past meetings, select an event from your schedule.",
	ScheduleMeetingPlaceholder_videoLinkText: "Learn more about meetings in Teaming",

	//
	// SelectedMeetingPanel
	//
	SelectedMeetingPanel_agendaTabTitle: "Agenda",
	SelectedMeetingPanel_reportTabTitle: "Report",
	SelectedMeetingPanel_teamGoalsTabTitle: "Goals",
	SelectedMeetingPanel_commitmentsTabTitle: "Action Items",
	SelectedMeetingPanel_pastMeetingsTabTitle: "Past Meetings",
	SelectedMeetingPanel_startMeetingButton: "Start Meeting",
	SelectedMeetingPanel_detailsButton: "Details",
	SelectedMeetingPanel_detailsButton__openTooltip: "Open context panel",
	SelectedMeetingPanel_detailsButton__closeTooltip: "Close context panel",
	SelectedMeetingPanel_joinMeetingButton: "Join meeting",
	SelectedMeetingPanel_oneOnOneType_label: "One-on-one",
	SelectedMeetingPanel_teamType_label: "Team meeting",
	SelectedMeetingPanel_noTeam_label: "Connect a team",
	SelectedMeetingPanel_leaveMeetingTitle: "Leave meeting",

	//
	// SyncButton
	//
	SyncButton_reSyncLabel: "Re-sync",
	SyncButton_syncingLabel: "Syncing",
	SyncButton_syncedLabel: "Synced",
	SyncButton_failedLabel: "Failed",

	//
	// MeetingAgendaTab
	//
	MeetingAgendaTab_agendaTitle: "Meeting Agenda",
	MeetingAgendaTab_reportTitle: "Meeting Report",
	MeetingAgendaTab_addTopicButton: "New topic",
	MeetingAgendaTab_removeConfirmation_headerText: "Remove a topic",
	MeetingAgendaTab_removeConfirmation_bodyText: "Do you want to remove this topic from your meeting?",
	MeetingAgendaTab_removePinnedConfirmation_headerText: "You’re removing a pinned topic",
	MeetingAgendaTab_removePinnedConfirmation_bodyText: "Do you want to delete only this occurrence of the topic, or this and all future occurrences?",
	MeetingAgendaTab_removePinnedConfirmation_confirmButtonText: "Only this instance",
	MeetingAgendaTab_removePinnedConfirmation_altConfirmButtonText: "This and future instances",
	MeetingAgendaTab_removePinnedConfirmation_cancelButtonText: "Cancel",
	MeetingAgendaTab_pendingFinalizationNotice: "Attendees may continue editing or adding outcomes until the organizer finalizes the meeting report.",
	MeetingAgendaTab_unpinConfirmation_headerText: "Unpin this topic?",
	MeetingAgendaTab_unpinConfirmation_bodyText: "Unpinning a topic will remove it from subsequent meetings in this series.",
	MeetingAgendaTab_unpinConfirmation_cancelButtonText: "No, cancel",
	MeetingAgendaTab_unpinConfirmation_confirmButtonText: "Yes, unpin",

	//
	// RequestTopicsButton
	//
	RequestTopicsButton_requestTopicsButton: "Request topics",
	RequestTopicsButton_topicRequestConfirmation: "Topics Requested",
	RequestTopicsButton_requestMenuTitle: "Request topics",
	RequestTopicsButton_requestMenuDescription: "We’ll send an email requesting topics from attendees. You’ll have the opportunity to arrange, edit, or remove any topics they add.",
	RequestTopicsButton_sendEmailButton: "Send email",
	RequestTopicsButton_dontSendEmailButton: "Don’t send",

	//
	// CommitmentsTab
	//
	CommitmentsTab_titleTeam: "Team Action Items",
	CommitmentsTab_title1On1: "Our Action Items",
	CommitmentsTab_titleNoTeam: "Meeting Action Items",
	CommitmentsTab_showCompletedItemsButton: "Show completed items",
	CommitmentsTab_loadMoreButton: "Load more",
	CommitmentsTab_hideCompletedItemsButton: "Hide completed items",
	CommitmentsTab_noOutstandingCommitments: "There are no outstanding action items for this meeting.",

	//
	// OneOnOneCreateFromInvitees
	//
	OneOnOneCreateFromInvitees_title: "New 1:1 relationship",
	OneOnOneCreateFromInvitees_alreadyExists_title: "This 1:1 relationship already exists",
	OneOnOneCreateFromInvitees_explanation: "One-on-one relationships are a unique, private context for managers, reports or peers to offer personal development, feedback and coaching.",
	OneOnOneCreateFromInvitees_alreadyExists_explanation: "A 1:1 relationship with these two people already exists. Would you like to assign it to this meeting?",
	OneOnOneCreateFromInvitees_name_label: "One-on-one name",
	OneOnOneCreateFromInvitees_name_help: "E.g. \"Name : Name\"",
	OneOnOneCreateFromInvitees_name_invalidError: "Please name your one-on-one.",
	OneOnOneCreateFromInvitees_name_note: "We’ve made a suggestion based on attendees. You may customize as desired.",
	OneOnOneCreateFromInvitees_members_label: "Participants",
	OneOnOneCreateFromInvitees_members_note: "Select your role in this 1:1 relationship.",
	OneOnOneCreateFromInvitees_special_note: "** Indicates an invitee with no matching Teaming account. On creating the relationship, they will be sent an invitation to join Teaming.",
	OneOnOneCreateFromInvitees_save_btn: "Create and assign to meeting",
	OneOnOneCreateFromInvitees_alreadyExists_save_btn: "Assign to meeting",
	OneOnOneCreateFromInvitees_save_btn_noAssign: "Create 1:1",
	OneOnOneCreateFromInvitees_cancel_btn: "Cancel",

	//
	// PastMeetingsTab
	//
	PastMeetingsTab_title: "Meeting Reports",
	PastMeetingsTab_loadMoreButton: "Load more",

	//
	// PastMeetingTopic
	//
	PastMeetingTopic_noOutcomesChip: "No outcomes recorded",
	PastMeetingTopic_deferredChip: "Deferred",

	//
	// PrivacyPlaceholderTab
	//
	PrivacyPlaceholderTab_viewMeetingTitle: "Privacy first.",
	PrivacyPlaceholderTab_viewMeetingMessage: "We believe one-on-one conversations should be kept private. Please confirm you intended to view this meeting before proceeding.",
	PrivacyPlaceholderTab_viewMeetingButton: "View meeting",

	//
	// TeamGoalsPlaceholderTab
	//
	TeamGoalsPlaceholderTab_loadingGoals_title: "Attempting to load team goals for this meeting. Please wait.",
	TeamGoalsPlaceholderTab_noGoals_title: "Looks like your team isn’t currently tracking any goals.",
	TeamGoalsPlaceholderTab_no1on1Goals_title: "Looks like you’re not currently tracking goals in this 1:1.",
	TeamGoalsPlaceholderTab_noGoals_description: "Create goals to keep your team focused on work that matters, while tracking progress toward key results.",
	TeamGoalsPlaceholderTab_no1on1Goals_description: "Goals empower you to stay focused on what matters, with a clear view of progress toward results that keep you moving forward.",
	TeamGoalsPlaceholderTab_createGoalButton: "Create a goal",
	TeamGoalsPlaceholderTab_noTeam_title: "Connect this meeting to a team or 1:1.",
	TeamGoalsPlaceholderTab_noTeam_description: "To view your team or 1:1 goals in Meeting Center, you first need to connect the meeting to your team or 1:1.",
	TeamGoalsPlaceholderTab_createTeamButton: "Connect a team",

	//
	// TeamGoalsTab
	//
	TeamGoalsTab_title: "Goals",
	TeamGoalsTab_addGoalButton: "Add goal",
	TeamGoalsTab_detailHeaderText: "Details",
	TeamGoalsTab_krprogressHeaderText: "KR Progress",
	TeamGoalsTab_pacingHeaderText: "Pacing",
	TeamGoalsTab_confidenceHeaderText: "Confidence",

	//
	// TeamConnector
	//
	TeamConnector_adhocLabel: "Ad hoc (no team)",
	TeamConnector_newTeamLabel: "New team",
	TeamConnector_newOneOnOneLabel: "New 1:1 relationship",
	TeamConnector_teamMenuLabel: "Teams",
	TeamConnector_oneOnOneMenuLabel: "1:1s",

	//
	// TeamCreateFromInvitees
	//
	TeamCreateFromInvitees_title: "New team from invitees",
	TeamCreateFromInvitees_name_label: "Team name",
	TeamCreateFromInvitees_name_help: "Sales, Product, Executive, etc.",
	TeamCreateFromInvitees_name_invalidError: "Please name your team.",
	TeamCreateFromInvitees_members_label: "Team members",
	TeamCreateFromInvitees_members_note: "Please verify and assign roles to the individuals who should be added to this team, and deselect anyone who should not be added (guests, etc.). You’ll be able to add others to the team after it’s been created.",
	TeamCreateFromInvitees_special_note: "** Indicates an invitee with no matching Teaming account. On creating the team, they will be sent an invitation to join Teaming.",
	TeamCreateFromInvitees_save_btn: "Create and assign to meeting",
	TeamCreateFromInvitees_cancel_btn: "Cancel",

	//
	// TeamSelector
	//
	TeamSelector_connectLabel: "Connect a team",

	//
	// PastMeetingsPlaceholderTab
	//
	PastMeetingsPlaceholderTab_title1: "Attempting to load past reports for this meeting. Please wait.",
	PastMeetingsPlaceholderTab_title2: "There are no past reports for this meeting.",
	PastMeetingsPlaceholderTab_description: "It looks like you haven’t yet conducted an instance of this meeting. After each meeting, we’ll save your outcome reports here for you to view at any time.",

	//
	// CommitmentsPlaceholderTab
	//
	CommitmentsPlaceholderTab_title1: "Attempting to load team action items for this meeting. Please wait.",
	CommitmentsPlaceholderTab_title2: "Looks like your team doesn’t have any action items yet.",
	CommitmentsPlaceholderTab_description: "Action items are tasks assigned to team members. You can create and assign action items while creating outcomes during your meetings.",

	//
	// StopMeetingButton
	//
	StopMeetingButton_title: "End this meeting?",
	StopMeetingButton_description1: "Ending the meeting stops the meeting timer. Attendees still have access to add or edit outcomes for 24 hours, or until the organizer finalizes and sends the report.",
	StopMeetingButton_description2: "If you have topics with no outcomes, you may want to consider deferring them before ending the meeting.",
	StopMeetingButton_endMeetingButton: "End meeting",
	StopMeetingButton_dontEndMeetingButton: "Don’t end meeting",

	//
	// JoinMeetingPlaceholderTab
	//
	JoinMeetingPlaceholderTab_title: "This meeting is now in progress.",
	JoinMeetingPlaceholderTab_description: "Join the meeting to participate in adding notes and outcomes.",
	JoinMeetingPlaceholderTab_joinMeetingButton: "Join meeting",

	//
	// ScheduleTopic
	//
	ScheduleTopic_titleOrQuestionPlaceholder: "Please type a question or title for your topic",
	ScheduleTopic_editHint: "Click the title or description to <strong>edit</strong>.",
	ScheduleTopic_noOutcomesChip: "No outcomes recorded",
	ScheduleTopic_deferredChip: "Deferred",
	ScheduleTopic_pinTooltip: "Pin topic to repeat<br/>in future meetings.",
	ScheduleTopic_unpinTooltip: "Unpin topic to remove</br/>from future meetings.",
	ScheduleTopic_descriptionPlaceholder: "Add a description",
	ScheduleTopic_removeConfirmation_headerText: "Remove an outcome",
	ScheduleTopic_removeConfirmation_bodyText: "Do you want to remove this outcome from your topic?",

	//
	// Authorize Calendar Access
	//
	AuthorizeCalendarAccess_header: "Calendar sync required",
	AuthorizeCalendarAccess_content: "Before you can run meetings in Teaming, we need to retrieve events from your calendar.",
	AuthorizeCalendarAccess_syncBtn: "Sync calendar",
	AuthorizeCalendarAccess_ErrorHeader: "Sync error.",
	AuthorizeCalendarAccess_ErrorContent: "There was a problem syncing your calendar events. Please try again.",
	AuthorizeCalendarAccess_SyncingHeader: "Syncing calendar events.",
	AuthorizeCalendarAccess_SyncingContent: "Your meetings will be displayed here shortly",
	AuthorizeCalendarAccess_SyncingBtnText: "Syncing",

	//
	// PreCalendarAuthVideo
	//
	PreCalendarAuthVideo_description: "Learn how to get the most out of your meetings with Teaming.",
	PreCalendarAuthVideo_videoTitle: "Meetings in Teaming",
};



// WEBPACK FOOTER //
// ./src/lang/en/schedule.js